import { inchesToFeetInches } from 'utils/math_util';

import type {
  RawWallPreviewSampleRoom,
  RawWallPreviewUserRoom,
  WallPreviewRoom,
} from './wall_preview_rooms.types';

function normalizeRoomData(
  room: RawWallPreviewSampleRoom | RawWallPreviewUserRoom
): WallPreviewRoom {
  const normalized: Partial<WallPreviewRoom> = { ...room };
  const previewImagePath = '/backgrounds/previews/';
  const imagePath = '/backgrounds/';

  if (room.type !== 'sample') {
    normalized.type = 'user';
    normalized.fullSrc = room.url;
    normalized.previewSrc = room.url;
    normalized.wallSize = room.wall_size;
    normalized.extraSpace = 0;
  } else {
    normalized.fullSrc = imagePath + room.filename;
    normalized.previewSrc = previewImagePath + room.filename;
  }

  const formattedSize = inchesToFeetInches(normalized.wallSize as number);
  normalized.displaySize = `${formattedSize[0]}ft ${formattedSize[1]}in`;

  return normalized as WallPreviewRoom;
}

export const sampleRooms: RawWallPreviewSampleRoom[] = [
  {
    id: 'sample01',
    type: 'sample',
    filename: 'bedroom.jpg',
    description: 'Bedroom',
    wallSize: 144.0,
    extraSpace: 0.0,
  },
  {
    id: 'sample02',
    type: 'sample',
    filename: 'family_room.jpg',
    description: 'Family Room',
    wallSize: 96.0,
    extraSpace: 17.0,
  },
  {
    id: 'sample03',
    type: 'sample',
    filename: 'gallery.jpg',
    description: 'Gallery',
    wallSize: 144.0,
    extraSpace: 42.0,
  },
  {
    id: 'sample04',
    type: 'sample',
    filename: 'holiday.jpg',
    description: 'Holiday',
    wallSize: 120.0,
    extraSpace: 12.0,
  },
  {
    id: 'sample05',
    type: 'sample',
    filename: 'kids_room.jpg',
    description: 'Kids Room',
    wallSize: 144.0,
    extraSpace: 0.0,
  },
  {
    id: 'sample06',
    type: 'sample',
    filename: 'living_room.jpg',
    description: 'Living Room 1',
    wallSize: 120.0,
    extraSpace: 0.0,
  },
  {
    id: 'sample07',
    type: 'sample',
    filename: 'living_room_02.jpg',
    description: 'Living Room 2',
    wallSize: 144.0,
    extraSpace: 0.0,
  },
  {
    id: 'sample09',
    type: 'sample',
    filename: 'seating_area.jpg',
    description: 'Seating Area 1',
    wallSize: 120.0,
    extraSpace: 0.0,
  },
  {
    id: 'sample10',
    type: 'sample',
    filename: 'seating_area_02.jpg',
    description: 'Seating Area 2',
    wallSize: 144.0,
    extraSpace: 0.0,
  },
];

export default {
  normalizeRoomData,
  sampleRooms,
};
